window.addEventListener("DOMContentLoaded", (event) => {    

    const currentUrl = window.location.href;
    if (currentUrl.includes("collections/shop-briefs-intimates")) {
        const viewport_width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0); 
        const product_thumbs = document.querySelectorAll('.collection__products .product-item');
        const mobile_double_grid = document.querySelector('section[data-collection-columns-mobile="2"]');
        const mobile_single_grid = document.querySelector('section[data-collection-columns-mobile="1"]');

        if(viewport_width <= 719 && mobile_double_grid !== null) {
            function renderMobileBundleBanner(insert_bundle_banner, product_thumb) {
                if(insert_bundle_banner == true) {
                    const bundle_banner = document.createElement('A');
                    bundle_banner.href = "/products/gooseberry-bundle";
                    bundle_banner.classList.add('bundle-banner_wrapper-mobile');
        
                    bundle_banner.innerHTML = `
                        <div class="bundle-banner_container">
                            <div class="bundle-banner-text-wrapper">
                                <h2 class="banner-title">Bundle and Save UP TO 20%</h2>
                            </div>
                            <div class="bundle-banner-tiers">
                                <p>Discount Tiers 3 items</p>
                                <p>3 items - 10% OFF</p><p>4 items - 15% OFF</p><p>5 items - 20% OFF</p></div><div class="bundle-banner-button">
                                <a href="/products/gooseberry-bundle">BUILD YOUR BUNDLE</a>
                            </div>
                        </div>
                        `;
        
                    const parentElement = product_thumb.parentNode;
                    parentElement.insertBefore(bundle_banner, product_thumb);    
                }
            }

            for(let i = 1; i < 5; i++) {
                insert_bundle_banner = false;
                if(i % 4 == 0){
                    insert_bundle_banner = true;
                }
                renderMobileBundleBanner(insert_bundle_banner, product_thumbs[i - 1]);
            }

            const product_thumbs_array = Array.from(product_thumbs);
            const product_thumbs_split = product_thumbs_array.slice(6, product_thumbs_array.length);

            for(let i = 1; i < product_thumbs_split.length; i++) {
                insert_bundle_banner = false;
                if(i % 10 == 0) {
                    insert_bundle_banner = true;
                }
            }
        } else if(viewport_width >= 720 || mobile_single_grid !== null) {
            if(viewport_width <= 719 && mobile_single_grid !== null) {
                for(let i = 1; i < 3; i++) {                      
                    insert_bundle_banner = false;
                    if(i % 2 == 0) {
                        insert_bundle_banner = true;
                    }
            
                    renderDesktopBundleBanner(insert_bundle_banner, product_thumbs[i - 1]);
                }
            } else {
                for(let i = 1; i < 7; i++) {                      
                    insert_bundle_banner = false;
                    if(i % 6 == 0) {
                        insert_bundle_banner = true;
                    }
            
                    renderDesktopBundleBanner(insert_bundle_banner, product_thumbs[i - 1]);
                }
            }

            const product_thumbs_array = Array.from(product_thumbs);
            const product_thumbs_split = product_thumbs_array.slice(8, product_thumbs_array.length);
            for(let i = 1; i < product_thumbs_split.length; i++) {                      
                insert_bundle_banner = false;
                if(i % 14 == 0) {
                    insert_bundle_banner = true;
                }

                renderDesktopBundleBanner(insert_bundle_banner, product_thumbs_split[i - 1]);
            }

            function renderDesktopBundleBanner(insert_bundle_banner, product_thumb) {
                if(insert_bundle_banner == true) {
                    const bundle_banner = document.createElement('DIV');            
                    bundle_banner.classList.add('product-item');
                    bundle_banner.classList.add('product-item--with-hover-swatches');
                    bundle_banner.classList.add('animation');
                    bundle_banner.classList.add('animation--item');
                    bundle_banner.classList.add('animation--item-initial');
                    bundle_banner.classList.add('animation--item-revealed');
                    bundle_banner.innerHTML = `
                        <a href="/products/gooseberry-bundle" class="bundle-banner-desktop_container">
                            <img src="https://cdn.shopify.com/s/files/1/1254/6073/files/bundle_and_save_big.png?v=1709224070"/>
                        </a>
                    `;
                    product_thumb.insertAdjacentElement("afterend", bundle_banner);         
                }
            }

        }
    }
});
